import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const EventStatusFilter = ({
    eventStatuses = [],
    loading = false,
    filters,
    restoreFilterValues,
}) => (
    <Field
        className='--customWidth --eventStatus'
        component={Form.ReduxSelect}
        disabled={loading}
        loading={loading}
        multiple
        name='eventStatus'
        options={eventStatuses}
        placeholder='Event status'
        search
        setValue={restoreFilterValues(filters, 'eventStatus')}
    />
);

EventStatusFilter.propTypes = {
    eventStatuses: PropTypes.array,
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};
